import getCookie from "@/utils/getCookie";
import {LocaleService, Locale} from "./LocaleService";
import { mapLangToLocale } from "@/utils/mapLangToLocale";
import { LangTypes } from "@/types/langTypes";
import { isCSE } from "@/utils/cse";

export default class LocaleServiceImpl implements LocaleService {
    getLocale(): Locale {
        const localizationFromWindow: string | undefined = window.locale
        const companyLangCookie = isCSE(localizationFromWindow as Locale)
            ? getCookie("companyLang") as LangTypes | undefined
            : undefined
        const localizationFromCookie = companyLangCookie ? mapLangToLocale(companyLangCookie) : null
    
        const localizationtoUse: Locale = localizationFromCookie ? localizationFromCookie : localizationFromWindow as Locale
        return localizationtoUse
    }
}